/* istanbul ignore file */
import { useUiTheme } from 'framework/uiTheme';
import type { FormPageLayoutProps } from '../../FormPageLayout/FormPageLayout';

const UpdatePageLayout = (props: FormPageLayoutProps) => {
  const { FormPageLayout } = useUiTheme<ReactComponent<FormPageLayoutProps>>();

  return <FormPageLayout {...props} />;
};

export default UpdatePageLayout;
